<template>
  <header>
    <div class="align" id="headBar">
      <div id="mainLogo">
        <IconBase :viewBox="'0 0 184 35'">
          <logo_FINMOLL></logo_FINMOLL>
        </IconBase>
      </div>
      <div id="midHead">
        <email></email>
        <phone></phone>
      </div>
      <button style="display:none;">ЗАКАЗАТЬ ЗВОНОК</button>
    </div>
  </header>
</template>

<script>
  export default {
    name: "headBar",
    components: {
      IconBase: () => import('@/components/svg/IconBase'),
      logo_FINMOLL: () => import('@/components/svg/logo_FINMOLL'),
      email:()=>import('@/components/chunk/email'),
      phone:()=>import('@/components/chunk/phone'),
    }
  }
</script>

<style scoped>
  #midHead {display: none;}
  button {background: #222721;color: #FFFFFF;width: 42vw;height: 10vw;font-size: 3.2vw;margin: 0}
  #headBar{display: flex;align-items: center;justify-content: space-between;height:13vw;}
  #mainLogo{width: 37.5vw;height: 7.2vw;}

  @media screen and (min-width: 760px) {
    #midHead {display: flex;width: 64vw;justify-content: flex-end;}
    /deep/ #midHead > div{width: 21.1vw;}
    #headBar{height: 5.3vw;}


    button{font-size: 1.1vw;width: 15.2vw;height: 3.7vw;}
    #mainLogo{width: 16.5vw;height: 3.1vw;}

  }

  @media screen and (min-width: 1140px) {
    button {font-size: 12px;width: 173px;height: 42px;}
    #headBar{height: 2.6vw;}
    #midHead{width: 760px;}
    /deep/ #midHead > div{width: 240px;}


    #mainLogo{width: 184px;height: 35px;}

  }
</style>

